import React from "react";
import { graphql } from "gatsby";
import { ExpertGuidanceStyles } from "../styles/PageExpertGuidance";
import {
  Container,
  ConvertedMarkdown,
  Accordion,
  VideoLibraryVertical,
  Seo
} from "../components";
// import { InterstitialInjector } from "../components/Injector";

const ExpertGuidance = ({ data }) => {
  const dataQuery = data.allMarkdownRemark.nodes[0],
        componentID = data.allMarkdownRemark.nodes[0].frontmatter.components_id,
        markdownHTML = data.allMarkdownRemark.nodes[0].html,
        vidTranscripts = dataQuery.frontmatter.videoTranscripts[0],
        // interstitials = data.allMarkdownRemark.nodes[0].frontmatter.interstitials,
        markdownID = `expert-guidance-content`;


  return (
    <>
      <Container markdownID={markdownID} componentID={componentID} query={dataQuery}>
        <ExpertGuidanceStyles id={`main`} className={`wrapper`}>
          <ConvertedMarkdown markdownID={markdownID} mdhtml={markdownHTML} />
          <VideoLibraryVertical videoTranscripts={vidTranscripts}/>
          {/* <InterstitialInjector query={interstitials}/> */}
          <Accordion />
          {/* <Definitions markdownID={markdownID} definitions={dataQuery.frontmatter.definitions}/> */}
        </ExpertGuidanceStyles>
      </Container>
    </>
  );
};


export const query = graphql`
  {
    allMarkdownRemark(
      filter: {frontmatter: {markdown_id: {eq: "expert-guidance-content"}}}
    ) {  
      nodes {
        frontmatter {
          slug
          description
          keywords
          markdown_id
          title
          canonicalUrl
          components_id
          definitions
          footnotes
          references
          url
          ogTitle
          ogDescription
          ogUrl
          ogImage
          ogImageAlt
          schema
          cta_next {
            copy
            link
            gtmlabel
          }
          interstitials {
            container
            trigger
            disclaimer
            setInner
            externalURL
            gtmlabel
          }
          videoTranscripts {
            vid_1
            vid_2
            vid_3
            vid_4
            vid_5
            vid_6
            vid_7
            vid_8
            vid_9
            vid_10
            vid_11
          }
        }
        id
        html
      }
    }
  }
`;

export const Head = ({ data }) => ( <Seo properties={data.allMarkdownRemark.nodes[0].frontmatter} /> );

export default ExpertGuidance;
